import {
  Box,
  Slider as CSlider,
  Flex,
  SliderFilledTrack,
  SliderProps,
  SliderThumb,
  SliderTrack,
  Text,
  TextProps,
} from '@chakra-ui/react';
import { CriteriaProps } from '~/screens/MyAgency/types';
import theme from '~/styles/theme';
import { convertPxToRems } from '~/utils-ts';

interface Props extends SliderProps {
  label?: string;
  marks: Array<CriteriaProps>;
  titleProps?: TextProps;
  'track-id'?: string;
}

export const Slider: React.FC<Props> = ({
  title,
  label,
  value,
  marks,
  step = 5,
  onChange,
  onChangeEnd,
  titleProps,
  isDisabled,
  'track-id': trackId,
  ...props
}) => (
  <Box marginTop={convertPxToRems(20)} track-id={trackId}>
    <Flex
      paddingBottom={convertPxToRems(8)}
      justifyContent="space-between"
      alignItems="center"
    >
      <Text fontSize="md" fontWeight="400" color="primary.400" {...titleProps}>
        {title}
      </Text>
      <Flex
        flexDirection="column"
        borderRadius={convertPxToRems(8)}
        backgroundColor="primary.50"
        color={value === 0 ? 'primary.200' : 'primary.400'}
        fontSize="md"
        fontWeight="medium"
        width={convertPxToRems(51)}
        height={convertPxToRems(24)}
        paddingRight={convertPxToRems(4)}
        justifyContent="center"
        alignItems="flex-end"
        data-testid="label"
      >
        {label || value}
      </Flex>
    </Flex>
    <Box width="100%">
      <Flex flexWrap="nowrap" gap={convertPxToRems(19)} whiteSpace="nowrap">
        {marks
          .filter((mark) => mark.display)
          .map((mark) => (
            <Box key={mark.value} flexGrow="1">
              <Text fontSize="sm">{mark.label}</Text>
            </Box>
          ))}
      </Flex>
      <CSlider
        value={value}
        defaultValue={marks[0].value}
        onChange={onChange}
        onChangeEnd={onChangeEnd}
        min={marks[0].value}
        max={marks[marks.length - 1].value}
        step={step}
        aria-label="slider"
        isDisabled={isDisabled}
        {...props}
      >
        <SliderTrack backgroundColor="secondary.50">
          <SliderFilledTrack backgroundColor="secondary.500" />
        </SliderTrack>
        <SliderThumb
          boxSize={convertPxToRems(12)}
          backgroundColor="secondary.200"
          _active={{
            backgroundColor: 'secondary.500',
            ...inputStyle,
          }}
          _hover={{
            backgroundColor: 'secondary.500',
            ...inputStyle,
          }}
          _focus={{
            backgroundColor: 'secondary.600',
            ...inputStyle,
          }}
          _focusVisible={{
            backgroundColor: 'secondary.600',
            ...inputStyle,
          }}
        />
      </CSlider>
    </Box>
  </Box>
);

const inputStyle = {
  border: `1px solid ${theme.colors.secondary[100]}`,
  outline: `3px solid ${theme.colors.secondary[100]}`,
  outlineOffset: 0,
};
